import axios from 'axios'

const BASE_URL = process.env.API_ENDPOINT

const toUrl = (path, ...subPath) => {
  return BASE_URL + path + subPath.join('/')
}

const getInstance = (token) => {
  return axios.create({
    headers: {'x-auth': token}
  })
}

export default {

  login: (email, password) => {
    return axios.post(toUrl('/users/login'), {
      email, password
    }).then(res => res.data)
  },

  me: (token) => {
    return getInstance(token).get(toUrl('/users/me')).then(res => res.data)
  },

  postVideo: (token, video) => {
    return getInstance(token)
      .post(toUrl('/videos'), video)
      .then(res => res.data)
  },

  postVideoTest: (token, video) => {
    return getInstance(token)
      .post(toUrl('/videos/test'), video)
      .then(res => res.data)
  },

  getVideos: () => {
    return axios.get(toUrl('/videos')).then(res => res.data)
  },

  getRandomVideos: (size = 9) => {
    return axios.get(toUrl(`/videos?random=${size}`)).then(res => res.data)
  },

  getVideo: (id) => {
    return axios.get(toUrl('/videos/', id)).then(res => res.data)
  },

  editVideo: (token, video, id) => {
    return getInstance(token)
      .patch(toUrl('/videos/', id), video)
      .then(res => res.data)
  },

  deleteVideo: (token, id) => {
    return getInstance(token)
      .delete(toUrl('/videos/', id))
      .then(res => res.data)
  },

  postGif: (token, id, gif) => {
    return getInstance(token)
      .post(toUrl('/gifs/', id), gif)
      .then(res => res.data)
  },

  getGifs: () => {
    return axios.get(toUrl('/gifs')).then(res => res.data)
  }
}



// WEBPACK FOOTER //
// ./src/api/thisism-api.js